import { render, staticRenderFns } from "./user-index.vue?vue&type=template&id=608a7e8a&scoped=true"
import script from "./user-index.vue?vue&type=script&lang=js"
export * from "./user-index.vue?vue&type=script&lang=js"
import style0 from "./user-index.vue?vue&type=style&index=0&id=608a7e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a7e8a",
  null
  
)

export default component.exports